var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "s12 border-bottom insety-16 fund-types" }, [
    _c(
      "div",
      {
        staticClass: "after-16 before-8",
        class: { "flex-flex": _vm.$media.l },
      },
      [
        _c("div", { staticClass: "text-semibold mf-label" }, [
          _vm._v(_vm._s(_vm.$t("fund_type"))),
        ]),
        _c(
          "div",
          { class: _vm.$media.l ? "start-32" : "before-16" },
          [
            _vm._l(_vm.fundTypes, function (item) {
              return item.val !== "break"
                ? _c(
                    "ib-radio",
                    {
                      key: item.val,
                      staticClass: "after-16 big-mobile",
                      class: {
                        "end-16": _vm.$media.l,
                        "after-24": !_vm.$media.l,
                      },
                      attrs: { name: "fundTypes", val: item.val },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                : item.val === "break" && _vm.$media.xl
                ? _c("br")
                : _vm._e()
            }),
            _c("span", { attrs: { else: "" } }),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }